import React from 'react'
import { useI18nContext } from '../_hooks/I18n'
import {
  StyledAnchor,
  StyledAnchorNavigation,
  StyledAnchorNavigationLandmark,
  StyledAnchorSection,
} from './AnchorNavigation.styles'
import type {
  AnchorNavigationProps,
  AnchorProps,
} from './AnchorNavigation.types'

const Anchor = ({ label, selected, onClick }: AnchorProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick()
    }
  }
  return (
    <StyledAnchorSection
      $selected={selected}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <StyledAnchor
        aria-current={selected ? 'page' : undefined}
        $selected={selected}
        tabIndex={0}
      >
        {label}
      </StyledAnchor>
    </StyledAnchorSection>
  )
}

export const AnchorNavigation = React.forwardRef<
  HTMLUListElement,
  AnchorNavigationProps
>(({ sections, selected, onSelect, 'aria-label': ariaLabelProp }, ref) => {
  const i18n = useI18nContext()
  const navigationAriaLabel =
    ariaLabelProp ?? i18n.t('core.anchorNavigation.landmarkLabel')

  return (
    <StyledAnchorNavigationLandmark aria-label={navigationAriaLabel}>
      <StyledAnchorNavigation ref={ref}>
        {sections.map(({ id, label }) => {
          return (
            <Anchor
              key={id}
              onClick={() => onSelect(id)}
              selected={selected === id}
              label={label}
            />
          )
        })}
      </StyledAnchorNavigation>
    </StyledAnchorNavigationLandmark>
  )
})
